<template>
  <div>
    <Carousel ref="galleryCarousel" v-model="currentSlide" :autoplay="autoplay" @mousedown="stopAutoPlay" @touchstart="stopAutoPlay" :wrap-around="true">
      <Slide v-for="image, imageKey in restaurant.images.slice(1)" :key="imageKey">
        <div class="rounded overflow-hidden">
          <AtomImage :src="useCloudinaryImage(image, 1200, 800, 'auto')" />
        </div>
      </Slide>
      <template #addons>
        <div class="flex gap-2 mt-2 md:gap-4 md:mt-4">
          <!-- <button class="btn" @click="galleryCarousel?.prev()">Prev</button> -->
          <button class="w-14 md:w-20 rounded overflow-hidden bg-black" v-for="thumb, thumbKey in restaurant.images.slice(1)" :key="thumbKey" @click="slideTo(thumbKey)">
            <AtomImage :src="useCloudinaryImage(thumb, 120, 120, 'auto')" class="duration-300" :class="{ 'opacity-40': thumbKey !== currentSlide }" />
          </button>
          <!-- <button class="btn" @click="galleryCarousel?.next()">Next</button> -->
        </div>
      </template>
    </Carousel>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  },
})

const galleryCarousel = ref(null)
const autoplay = ref(4000)
const currentSlide = ref(0)

// Prevent autoplay in carousel
const stopAutoPlay = () => {
  autoplay.value = 0
}

// Slide to a specific slide
const slideTo = (slide) => {
  currentSlide.value = slide
}
</script>

<style lang="scss" scoped>
// 
</style>